// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".campaign-list-item td[data-v-b4fd83cc]{padding:16px 0!important;vertical-align:top}.campaign-list-item__name[data-v-b4fd83cc]{font-weight:700;text-transform:uppercase}td.campaign-list-item__name[data-v-b4fd83cc]{width:230px}", ""]);
// Exports
module.exports = exports;
